export default "__VITE_ASSET__7d440830__"